import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import Footer from "./components/Footer";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import AMCContracts from "./pages/AMCContracts";
import Invoices from "./pages/Invoices";
import WorkOrders from "./pages/WorkOrders";
import Login from "./pages/Login";
import "./App.css";

export default function App() {
  const [user, setUser] = useState(() => {
    try {
      const saved = sessionStorage.getItem("ihrd_user");
      return saved ? JSON.parse(saved) : null;
    } catch { return null; }
  });

  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem("ihrd_theme") || "dark";
    } catch { return "dark"; }
  });

  useEffect(() => {
    document.body.classList.remove("theme-dark", "theme-light");
    document.body.classList.add(`theme-${theme}`);
    try {
      localStorage.setItem("ihrd_theme", theme);
    } catch {}
  }, [theme]);

  const toggleTheme = () => setTheme(prev => prev === "dark" ? "light" : "dark");

  const handleLogin = (username, role) => {
    const u = { username, role };
    sessionStorage.setItem("ihrd_user", JSON.stringify(u));
    setUser(u);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("ihrd_user");
    setUser(null);
  };

  if (!user) return <Login onLogin={handleLogin} />;

  const role = user.role;

  return (
    <BrowserRouter>
      <div className="app-root">
        <Header
          role={role}
          username={user.username}
          theme={theme}
          onToggleTheme={toggleTheme}
          onLogout={handleLogout}
        />
        <div className="app-body">
          <Sidebar />
          <main className="app-main">
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard role={role} />} />
              <Route path="/customers" element={<Customers role={role} />} />
              <Route path="/amc" element={<AMCContracts role={role} />} />
              <Route path="/invoices" element={<Invoices role={role} />} />
              <Route path="/work-orders" element={<WorkOrders role={role} />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </main>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
}
